import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

//import { TreeNode } from 'primeng/api';

import { Downloads } from '../../shared/services/downloads';
import { Applications } from '../../shared/services/applications';
import { Application } from '../../shared/services/application';
import { LinkedInvestments } from '../../shared/services/linked-investments';
import { Investors } from '../../shared/services/investors';
import { InvestmentDetails } from '../../shared/services/investment-details';
import { PolicyDocuments } from '../../shared/services/policy-documents';
import { AppRegDetails } from '../../shared/services/appreg-details';
import { Note } from '../../shared/services/note';


import { RedemptionApplications } from '../../shared/services/redemption-applications';
import { SupportingDocuments } from '../../shared/services/supporting-documents';

@Injectable()
export class NodeService {

    constructor(private http: HttpClient) { }

    getDownloads() {
        return this.http.get<any>('../assets/data/downloads.json')
            .toPromise()
            .then(res => <Downloads[]>res.data);
    }

    getApplications() {
        return this.http.get<any>('../assets/data/applications.json')
            .toPromise()
            .then(res => <Applications[]>res.data);
    }

    getRedemptionApplications() {
        return this.http.get<any>('../assets/data/redemption-applications.json')
            .toPromise()
            .then(res => <RedemptionApplications[]>res.data);
    }

    getSupportingDocuments() {
        return this.http.get<any>('../assets/data/supporting-documents.json')
            .toPromise()
            .then(res => <SupportingDocuments[]>res.data);
    }

    getApplicationDetails() {
        return this.http.get<any>('../assets/data/application-details.json')
            .toPromise()
            .then(res => <Application[]>res.data);
    }

    getLinkedInvestments() {
        return this.http.get<any>('../assets/data/linked-investments.json')
            .toPromise()
            .then(res => <LinkedInvestments[]>res.data);
    }

    getInvestors() {
        return this.http.get<any>('../assets/data/investors.json')
            .toPromise()
            .then(res => <Investors[]>res.data);
    }

    getInvestmentDetails() {
        return this.http.get<any>('../assets/data/investment-details.json')
            .toPromise()
            .then(res => <InvestmentDetails[]>res.data);
    }

    getPolicyDocuments() {
        return this.http.get<any>('../assets/data/policy-documents.json')
            .toPromise()
            .then(res => <PolicyDocuments[]>res.data);
    }

    getAppRegDetails() {
        return this.http.get<any>('../assets/data/appreg-details.json')
            .toPromise()
            .then(res => <AppRegDetails[]>res.data);
    }

    getNotes() {
        return this.http.get<any>('../assets/data/note.json')
            .toPromise()
            .then(res => <PolicyDocuments[]>res.data);
    }

    getAuditHistory() {
        return this.http.get<any>('../assets/data/audit-history.json')
            .toPromise()
            .then(res => <PolicyDocuments[]>res.data);
    }
}
